import { render } from "./aclmanage.vue?vue&type=template&id=0b251737&scoped=true"
import script from "./aclmanage.vue?vue&type=script&lang=js"
export * from "./aclmanage.vue?vue&type=script&lang=js"

import "./aclmanage.vue?vue&type=style&index=0&id=0b251737&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b251737"]])

export default __exports__